var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparator__card__panel"},[_c('img',{staticClass:"comparator__card__panel__img",attrs:{"src":_vm.imageSrc}}),_c('p',{staticClass:"comparator__card__panel__text"},[_vm._v(" "+_vm._s(_vm.$t('home.comparator.noOffers'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }